<template>
  <div>
    <div class="d-flex justify-content-center height" v-if="(project==null || statuses==null)">
      <div class="spinner-border text-primary">
        <span class="sr-only">در حال بارگذاری ...</span>
      </div>
    </div>
    <div v-else>
      <tickets :url="'api/project/get/tickets/' + this.$route.params.id" :project_id="this.$route.params.id"/>
    </div>
  </div>
</template>

<script>
import tickets from '@/components/tickets.vue'
export default {
  components: {
    tickets
  },
  props: ['project', 'statuses'],
  methods: {
    changeStatus (status) {
      this.$send.submit('post', 'api/project/status/' + status + '/' + this.$route.params.id)
        .then(response => {
          this.project.status = status
        })
    }
  }
}
</script>
